import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { FichaTecnicaDirective } from '../../../directives/ficha-tecnica.directive';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    imports: [RouterLink, RouterLinkActive, FichaTecnicaDirective],
})
export class FooterComponent {
    currentYear: number = new Date().getFullYear();
}
